// Job statuses as stored by the backend (models.cci.CciJobStatus), in display order
export const CCI_JOB_STATUSES = ['queued', 'leased', 'succeeded', 'failed', 'expired', 'superseded'];

// Superseded jobs were replaced by a newer push before running; hidden unless asked for
export const DEFAULT_CCI_STATUSES = CCI_JOB_STATUSES.filter((s) => s !== 'superseded');

const KINDS = {
  queued: 'warn',
  leased: 'info',
  succeeded: 'ok',
  failed: 'err',
  expired: 'err',
  superseded: 'neutral',
};

const LABELS = {
  queued: 'Queued',
  leased: 'Running',
  succeeded: 'Succeeded',
  failed: 'Failed',
  expired: 'Expired',
  superseded: 'Skipped',
};

export const cciStatusKind = (status) => KINDS[status] ?? 'neutral';
export const cciStatusLabel = (status) => LABELS[status] ?? status;

// Runner-reported states (job report and per-profile), coloured like job statuses
const RUN_KINDS = {
  accepted: 'warn', running: 'info',
  succeeded: 'ok', cached: 'ok',
  failed: 'err', timed_out: 'err', error: 'err',
};

export const runStateKind = (state) => RUN_KINDS[state] ?? 'neutral';

// What made GitHub ask for checks: the webhook event type plus its action
const TRIGGER_LABELS = {
  'pull_request:opened': 'PR opened',
  'pull_request:synchronize': 'PR synchronized',
  'pull_request:reopened': 'PR reopened',
  'merge_group:checks_requested': 'Merge queue',
};

export const triggerLabel = (event) => {
  if (!event) return '—';
  if (event.type === 'merge_group') return 'Merge queue';
  return TRIGGER_LABELS[`${event.type}:${event.action}`]
    ?? (event.action ? `${event.type} ${event.action}` : event.type);
};

export const shortSha = (sha) => (sha ? sha.slice(0, 7) : '—');

export const prUrl = (event) => (
  event?.pr_number ? `https://github.com/${event.repo}/pull/${event.pr_number}` : null
);

export const commitUrl = (repo, sha) => `https://github.com/${repo}/commit/${sha}`;

export const formatSeconds = (seconds) => {
  if (seconds === null || seconds === undefined) return '—';
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  return `${Math.floor(seconds / 60)}m ${Math.round(seconds % 60)}s`;
};

export const formatBytes = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
